import {
  ServiceRequestFormContextValue,
  useServiceRequestFormContext,
} from 'src/components/ServiceRequestForm/CustomHooks/ServiceRequestFormContext';

export interface UseServiceRequestFormQuestionOrchestratorReturn {
  faq: any;
  onProceed: () => void;
  onBack: () => void;
  onExit: () => void;
}

export const useServiceRequestFormQuestionOrchestrator =
  (): UseServiceRequestFormQuestionOrchestratorReturn => {
    const {
      formData,
      goNext,
      goPrev,
      onExit,
      reference,
    }: ServiceRequestFormContextValue = useServiceRequestFormContext();

    const { catalogItems } = reference;

    const selectedItem: any = catalogItems.find(
      (item: any) => item.id === formData.asset_item_id
    );

    const itemFaqs: any[] = selectedItem?.faqs ?? [];

    const faq: any =
      itemFaqs.find((itemFaq: any) => itemFaq.id === formData.faq_id) ?? {};

    const onProceed = (): void => {
      goNext();
    };

    const onBack = (): void => {
      goPrev();
    };

    return {
      faq,
      onProceed,
      onBack,
      onExit,
    };
  };